import {Role} from '../app/core/_model'

export const Cashier: Role = {label: 'Kasir', value: 'CASHIER'}
export const Office: Role = {label: 'Office', value: 'OFFICE'}
export const OfficeRestricted: Role = {label: 'Office', value: 'OFFICE_RESTRICTED'}
export const SystemAdministrator: Role = {label: 'System Administrator', value: 'SYS_ADMIN'}
export const Administrator: Role = {label: 'Owner', value: 'OWNER'}
